import React from 'react'
import { useTranslation } from 'react-i18next'

import { ADMIN, MANAGER, REPORT } from '../../../../../../constants/selfAccounts'

import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'

const RightHolderRoleDescription = ({ role, rightsHolderName }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  switch (role) {
    case ADMIN:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Admin permissions:')}</h3>
          <p>
            Access to all partner accounts <br />
            Set up and manage partners and partnerships <br />
            Manage all campaigns (must have ad account access) <br />
            Manage {rightsHolderName} and partner teams <br />
            Manage margins and other settings <br />
          </p>
        </>
      )
    case MANAGER:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign Manager permissions:')}</h3>
          <p>
            Only access partners they are added to <br />
            Manage partner campaigns (must have ad account access)
          </p>
        </>
      )
    case REPORT:
    default:
      return (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{t('Reporting Only permissions:')}</h3>
          <p>
            Only access partners they are added to <br />
            Report on partner campaigns (must have ad account access)
          </p>
        </>
      )
  }
}

export default RightHolderRoleDescription
